import React from "react";

/**
 * TotalsCell component for displaying attendance code totals and percentages
 * @param {Object} props
 * @param {Object} props.totals - Object with code counts
 * @param {Array} props.columnOrder - Array of codes to define column order
 * @param {number} props.totalDays - Total number of days in the current view
 */
const TotalsCell = ({
  totals,
  columnOrder = ["P", "T", "C", "L", "I"],
  totalDays, // default fallback
}) => {

  return (
    <>
      {columnOrder.map((code) => {
        const count = totals[code] || 0;
        const percentage = totalDays > 0 ? ((count / totalDays) * 100).toFixed(0) : 0;

        return (
          <div key={code} className="attendance-cell total-cell">
            {count > 0 ? `${count} (${percentage}%)` : ""}
          </div>
        );
      })}
    </>
  );
};

export default TotalsCell;
